import { G_appliedClasses } from "../../../utils/globals/globals";

/**
 * Add or remove the class from the global map
 * This is used when destroying the TorusKit instance. It stores all classes
 * applied by the ClassObserver
 * @param {Node} element HTML element
 * @param {String} name Class name
 * @param {Boolean} add Adding or removing the class
 */
const changeAppliedClasses = (element, name, add) => {
  if (!G_appliedClasses.get(element)) {
    G_appliedClasses.set(element, new Set());
  }

  /** Set of classes for  */
  const set = /** @type {Set<String>} */ (G_appliedClasses.get(element));

  add ? set.add(name) : set.delete(name);
};

export default changeAppliedClasses;
